import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, isRef as _isRef, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-84c1a704")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("mdi-plus")
const _hoisted_2 = { class: "mb-4 text-subtitle" }
const _hoisted_3 = { class: "ml-4 text-error text-caption" }
const _hoisted_4 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "ml-4 text-error text-caption" }
_popScopeId()

import { withDefaults, ref, onMounted, PropType } from 'vue'
import Action from '../../Dialog/enums/DialogAction'
import TheDialog from '../../Dialog/TheDialog.vue'
import createHoppermationAPIClient from '@/clients/hoppermation'
// TODO vuetify 3 validation, replace as soon as available
import { Field, useField, useForm } from 'vee-validate'
import { required } from '@/lib/validation'
import { IChannel } from '@/interfaces/hoppermation'
import { AxiosInstance } from 'axios'
import { useRouter } from 'vue-router'

interface IProps {
  channels?: PropType<IChannel[]>
}


export default /*#__PURE__*/_defineComponent({
  props: {
    channels: { type: null, required: false, default: () => [] }
  },
  setup(__props: any) {

const props = __props as { channels: PropType<IChannel[]> }


const router = useRouter()
const hoppermationApiClient = ref({} as AxiosInstance)
const serverError = ref('')
const channel = ref('')
const action = Action.CREATE
const rules = { required }
const { validate: validateName, errorMessage: errorName, value: name } = useField('name', required)
const { validate } = useForm()

onMounted(async () => {
  hoppermationApiClient.value = await createHoppermationAPIClient()
})

const createAutomation = async (): Promise<boolean> => {
  const { valid: validName } = await validateName()
  const { valid: validChannel } = await validate()

  if (validName && validChannel) {
    const data = {
      channelId: channel.value,
      name: name.value,
      tags: []
    }

    try {
      const res = await hoppermationApiClient.value.post('/automations', data)
      router.push({
        name: 'Editor',
        params: { id: res.data.id }
      })
      return true

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      serverError.value = error.response.data.message[0]
      return false
    }
  }
  return false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(TheDialog, {
    action: _unref(action),
    title: _ctx.$t('dialog.create.title'),
    submit: createAutomation,
    imageSrc: "https://assets8.lottiefiles.com/packages/lf20_u25cckyh.json",
    errors: serverError.value
  }, {
    activator: _withCtx(({ props }) => [
      _createVNode(_component_v_btn, _mergeProps(props, { color: "primary" }), {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('dialog.create.activator')) + " ", 1),
          _createVNode(_component_v_icon, null, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 2
      }, 1040)
    ]),
    content: _withCtx(() => [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('dialog.create.desc')), 1),
      _createVNode(_component_v_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: _normalizeClass(["row-max", _unref(errorName) ? 'mb-3' : ''])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    name: "name",
                    modelValue: _unref(name),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? name.value = $event : null)),
                    "persistent-hint": "",
                    label: _ctx.$t('dialog.create.automationName.label'),
                    hint: _ctx.$t('dialog.create.automationName.hint'),
                    class: "mb-0"
                  }, null, 8, ["modelValue", "label", "hint"]),
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(errorName) ? _ctx.$t(_unref(errorName)) : ''), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_v_row, { class: "row-max" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "px-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Field), {
                    name: "channel",
                    rules: rules.required,
                    modelValue: channel.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (channel.value = $event))
                  }, {
                    default: _withCtx(({ field, errorMessage }) => [
                      _createElementVNode("select", _mergeProps(field, { class: "px-4 width-full select" }), [
                        _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.$t('dialog.create.channel.unselected')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.channels, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: item.id
                          }, _toDisplayString(item.name), 9, _hoisted_5))
                        }), 128))
                      ], 16),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(errorMessage ? _ctx.$t(errorMessage) : ''), 1)
                    ]),
                    _: 1
                  }, 8, ["rules", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["action", "title", "errors"]))
}
}

})